import React from "react";
import { useTranslation } from "react-i18next";
import { LeaveAlertProps } from "../../types/Popups";
import Button from "../GeneralComponents/Button";
import Modal from "../GeneralComponents/Modal";

const LeaveAlert: React.FC<LeaveAlertProps> = ({
  setShow,
  show,
  handleConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={show}
      height="fit-content"
      onClose={() => {
        setShow(!show);
      }}
      maxWidth="max-w-xl"
      disableCancel={true}
    >
      <p className="text-lg font-bold text-headingTextColor">
        {t("leaving_confirm")}
      </p>
      <p className="mb-6 text-base font-normal text-textColor">
        {t("leaving_page_desc")}
      </p>
      <div className="flex items-center justify-end gap-3">
        <Button
          title={t("cancel")}
          variant="secondary"
          onClick={() => {
            setShow(!show);
          }}
          extraClassName="!w-fit !font-bold"
        />
        <Button
          title={t("exit")}
          variant="primary"
          onClick={() => handleConfirm()}
          extraClassName="!w-fit"
        />
      </div>
    </Modal>
  );
};

export default LeaveAlert;
